export enum PurchaseOrderStatusEnum {
    NEW = 1,
    NOT_FINALISED = 2,
    READY_TO_BE_PLACED = 3,
    READY_TO_BE_PLACED_EDITED = 4,
    GOODS_IN_TRANSIT = 5,
    GOODS_RECEIVED_NO_OK = 6,
    CLOSED = 7,
    REFUSED = 8,
    TRANSFER_IN_TRANSIT=9,
    CLOSED_AFTER_REOPENED = 10
  }
  
  /**
   * Keep in sync with `PurchaseOrderStatusEnum` and values in `purchaseorderStatustatus` table in the Database.
   */
  export enum PurchaseOrderStatusNameValueEnum {
    NEW = 'New',
    NOT_FINALISED = 'Not Finalised',
    READY_TO_BE_PLACED = 'Ready to be Placed',
    READY_TO_BE_PLACED_EDITED = 'Ready to be Placed (Edited)',
    GOODS_IN_TRANSIT = 'Goods In Transit',
    GOODS_RECEIVED_NO_OK = 'Goods Received No OK',
    CLOSED = 'Closed',
    REFUSED = 'Refused',
    TRANSFER_IN_TRANSIT='Transfer In Transit',
    CLOSED_AFTER_REOPENED = 'Closed After Reopened',
  }
  